var Mn = require('backbone.marionette');
var scope = require('scope');
var JqModal = require('jquery-modal');
var Carousel = require('./Carousel');
var ignoreduplicate = null;

module.exports = Mn.Behavior.extend({
    onAttach: function () {
        if (this.$el.find('a[data-modal],a[data-modal-youtube]').length) {
            this.build(this.$el);
            if (this.$el.find('[data-open-modal]').length) {
                $('a[data-modal]', this.$el).trigger('click');
            }
        }
    },
    onChildviewAttach: function (view) {
        var content = view.$el;
        if (content.find('a[data-modal]').length) {
            this.build(content);
        }
    },

    build: function (content) {
        var options = {};
        var self = this;

        if ($(content).data('modal-init'))
            return;

        $(content).data('modal-init', true);

        content.on('click', 'a[data-modal]', function (e) {
            e.preventDefault();

            if (ignoreduplicate) return;
            ignoreduplicate = true;

            setTimeout(function(){
                ignoreduplicate = false;
            }, 100);

            var target = $(e.currentTarget);
            var content = $(target.attr('href'));
            var modifier = content.data('modifier');

            self.setGalleryContent(target, content);

            if (modifier) {
                options.modalClass = 'modal modal-' + modifier;
                options.blockerClass = 'jquery-modal jquery-modal-' + modifier;
            }

            content.on('modal:open', function () {
                $('.close-modal').click(function (e) {
                    e.preventDefault();
                }).attr('data-bypass');
            });

            content.on('modal:close', function () {
                // scope.app.loading(false);
            });

            $(this).modal(options);
        });

        $(document).on('click','a[data-modal-youtube]', function(e){

            e.preventDefault();

            var elem = $(this),
                id = elem.data('video-id');
            $('#highlight-modal .video iframe').attr('src','https://www.youtube.com/embed/'+id+'?rel=0');

        });

        PANAMERICANA.app.router.real.on('route', function () {
            $('.jquery-modal a[rel="modal:close"]').each(function () {
                $(this).trigger('click');
            });
        });
    },
    setGalleryContent: function (target, content){
        if (typeof target.data('pass-content') !== 'undefined') {
            var images = target.data('content-images');
            var title = target.data('content-title');
            var caption = target.data('content-caption');
            var course = target.data('content-course');

            var template = $(content.find('#showcase-item').html());
            var html = '';

            content.find('[data-content-title]').text(title);
            content.find('[data-content-caption]').text(caption);
            content.find('[data-content-course]').text(course);

            content.find('.showcase__carousel').slick("unslick");

            for(var x = 0; x < images.length; x++){
                
                template = $(content.find('#showcase-item').html());

                if(images[x].indexOf('http') == 0){
                    template.find('[data-content-image]').attr('src', images[x]).attr('title', title);
                    template.find('[data-content-video]').remove();
                    html += template.html();
                } else {
                    template.find('[data-content-video]').attr('src', 'https://www.youtube.com/embed/'+images[x]+'?rel=0');
                    template.find('[data-content-image]').remove();
                    html += template.html();
                }

            }

            content.find('.showcase__carousel').html(html).promise().done(function() {
                $(this).find("img").first().one("load", function() {
                    Carousel.prototype.build(content, true);
                }).each(function() {
                    if(this.complete) {
                        // $(this).load(); // For jQuery < 3.0 
                        $(this).trigger('load'); // For jQuery >= 3.0 
                    }
                });
            });
            
            // Carousel.prototype.build(content, true);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/behaviors/Modals.js
// module id = 227
// module chunks = 3